window.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-js="plan-popup"]');
  const backdrop = document.getElementById('product-selection-backdrop');

  if (popup && backdrop) {
    const planBtns = document.querySelectorAll('[data-js="plan-btn"]');
    const popupTitle = document.querySelector('[data-js="plan-popup_title"]')
    const popupNotice = document.querySelector('[data-js="plan-popup_notice"]')

    backdrop.addEventListener('click', () => {
      popup.classList.add('display-none');
      backdrop.classList.add('display-none');
    })

    planBtns.forEach((planBtn) => {
      planBtn.addEventListener('click', () => {
        const title = planBtn.querySelector('[data-js="card_plan"]').innerHTML;
        const notice = planBtn.querySelector('[data-js="card_notice"]').innerHTML;
        popupTitle.innerHTML = title + "が選択されました";
        popupNotice.innerHTML = "※<br>" + notice;
        popup.classList.remove('display-none');
        backdrop.classList.remove('display-none');
      })
    })
  }
});
